/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../organization-settings/organization.settings.model.ts" />

module Eseebase {
    export class StatisticsViewModel {
        companies: CompanyStatisticsViewModel[];
        total: CompanyStatisticsViewModel;
    }

    export class CompanyStatisticsViewModel {
        companyName: string;
        associations: number;
        departments: number;
        users: number;
        apartments: number;
        files: number;
    }
}